<!--
  Tooltip Component
  CSS-only hover tooltip. Wraps the trigger element.
-->
<script lang="ts">
  export let text: string;
  export let position: 'top' | 'bottom' | 'left' | 'right' = 'top';

  const positionClasses: Record<string, string> = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };
</script>

<div class="relative inline-flex group">
  <slot />
  <div
    class="absolute {positionClasses[position]} px-2 py-1 text-xs text-text bg-surface-hover
      border border-border rounded shadow-card whitespace-nowrap
      opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible
      transition-all duration-150 pointer-events-none z-50"
    role="tooltip"
  >
    {text}
  </div>
</div>
